import { Button } from "@/components/ui/button";
import { useNavigate, Link } from "react-router-dom";

const Terms = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        <Link to="/">
          <Button variant="ghost" className="mb-8">
            ← Back to Home
          </Button>
        </Link>

        <div className="bg-white p-8 rounded-lg shadow-sm">
          <h1 className="text-3xl font-bold text-gray-900 mb-8">Terms & Conditions</h1>
          
          <div className="space-y-6 text-gray-600">
            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">1. Acceptance of Terms</h2>
              <p>By accessing and using our data services platform, you agree to be bound by these Terms & Conditions and all applicable laws and regulations.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">2. Service Description</h2>
              <p className="mb-4">Our platform provides access to data services through:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Search engine functionality for product data</li>
                <li>Data export capabilities</li>
                <li>API access for integration purposes</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">3. Subscription Plans</h2>
              <p className="mb-4">We offer various subscription tiers:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Monthly subscription plans with flexible payment options</li>
                <li>Annual subscription plans with preferential pricing</li>
                <li>Enterprise solutions for custom requirements</li>
              </ul>
              <p className="mt-4">All subscriptions are subject to automatic renewal unless cancelled before the renewal date.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">4. Credit System</h2>
              <p className="mb-4">Our credit system operates as follows:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Credits are allocated based on your subscription tier</li>
                <li>Each data export consumes credits based on the number of rows</li>
                <li>Search engine queries consume credits according to usage</li>
                <li>Unused credits expire at the end of the billing cycle</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">5. Usage Restrictions</h2>
              <p className="mb-4">Users must not:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Share account credentials with unauthorized users</li>
                <li>Attempt to circumvent usage limits or credit system</li>
                <li>Scrape or bulk download data beyond permitted limits</li>
                <li>Reverse engineer or modify our services</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">6. Data Usage Rights</h2>
              <p>Users receive a non-exclusive, non-transferable license to use exported data for internal business purposes only. Redistribution or resale of data requires written permission.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">7. Service Level Agreement</h2>
              <p>We strive to maintain 99.9% uptime for our services. Scheduled maintenance will be communicated in advance. Service credits may be issued for extended downtime.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">8. Termination</h2>
              <p>We reserve the right to terminate or suspend access to our services for violations of these terms or non-payment. Users may cancel their subscription at any time.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">9. Changes to Terms</h2>
              <p>We may modify these terms at any time. Continued use of the service after changes constitutes acceptance of the new terms.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">10. Contact</h2>
              <p>For questions about these terms, please contact us through our contact page.</p>
            </section>
          </div>

          <div className="mt-8">
            <Button
              variant="outline"
              onClick={() => navigate(-1)}
              className="w-full sm:w-auto"
            >
              Go Back
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Terms;